/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:20:09
 * @ Modified by: David Helmick
 * @ Modified time: 2024-08-02 18:44:46
 * @ Description: funcction that handles the signout proocedure
 */

import { resetMixpanel } from '@/analytics/mixpanel'

export function signOut (client, member = null) {
  // Clear auth first so any in-flight/refetched queries don't run with stale credentials
  // if (member === 'RWN')
  //   navigate('RWNRedirect')
  // if (member === 'GRE')
  //   navigate('GRERedirect')
  try {
    resetMixpanel()
  } catch (_e) {
    // ignore
  }
  localStorage.clear()
  try {
    // Prefer clearStore to avoid auto-refetching queries during logout.
    // Fallback to resetStore for older Apollo clients.
    if (client?.clearStore) {
      client.clearStore()
    } else if (client?.resetStore) {
      client.resetStore()
    }
  } catch (e) {
    // Best-effort; we still want to complete logout.
    console.warn('signOut: failed to clear apollo store', e)
  }
  // Force navigation to signed-out routes immediately to avoid transient renders
  // of signed-in UI while session data is being cleared.
  try {
    if (typeof window !== 'undefined') {
      window.location.assign('/signin' + window.location.search)
    }
  } catch (e) {
    // no-op
  }
  // history.push(routes.SIGN_IN)
}